module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "disableOutsideClick": true,
      "title": ("You have to connect your\n        " + (_vm.selectedIntegration.name) + " Account."),
      "size": 'md'
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "center mv4"
  }, [_c('p', {
    staticClass: "tc px-7 txt-modal-upgrade"
  }, [_vm._v("\n      You must connect your " + _vm._s(_vm.selectedIntegration.name) + " account to your\n      Parlay account before you can use the LMS integration. You must go to\n      your Profile Integrations page to set up the connection.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "integrations-container w-70"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.icon,
      "height": "50px",
      "width": "50px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "integration-classroom-title ml3"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedIntegration.name) + "\n        ")])]), _vm._v(" "), _c('button', {
    staticClass: "px-4 py-2 bg-primary text-white rounded font-semibold truncate-text",
    on: {
      "click": _vm.goToProfileIntegrations
    }
  }, [_vm._v("\n        Set Up Connection\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3b666fe2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/integrationsConnectAccountModal.vue
// module id = 2438
// module chunks = 61